/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNeutral56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M23.32 36.75h-4.07v-17.5h4.865l7.323 10.032c.472.69.918 1.479 1.191 2.12h.05V19.25h4.071v17.5h-4.617l-7.596-10.155c-.422-.665-.918-1.454-1.166-2.046h-.075c.025.74.025 1.504.025 2.342v9.859zM44.75 43.5v-3.833h1.5V43.5a2.75 2.75 0 01-2.75 2.75h-5.778v-1.5H43.5c.69 0 1.25-.56 1.25-1.25zM28 44.75h5.833v1.5H28v-1.5zM11.25 17.5v-5c0-.69.56-1.25 1.25-1.25h6.75v-1.5H12.5a2.75 2.75 0 00-2.75 2.75v5h1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M9.25 4.5A4.75 4.75 0 004.5 9.25v37.5a4.75 4.75 0 004.75 4.75h37.5a4.75 4.75 0 004.75-4.75V9.25a4.75 4.75 0 00-4.75-4.75H9.25zM6 9.25A3.25 3.25 0 019.25 6h37.5A3.25 3.25 0 0150 9.25v37.5A3.25 3.25 0 0146.75 50H9.25A3.25 3.25 0 016 46.75V9.25z'
      />
    </svg>
  );
}

export default SvgNeutral56;
